// extracted by mini-css-extract-plugin
export default {"root":"CopyAPIKeyField_root__HPRtR","key":"CopyAPIKeyField_key__HGl4Z"};